import React from 'react';
import { Clock, UtensilsCrossed } from 'lucide-react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { PromoBanner } from '../components/PromoBanner';
import { media } from '../data/media';
import { useLanguage } from '../contexts/LanguageContext';
export function Recettes() {
  const {
    t
  } = useLanguage();
  return <>
      <PageHeader eyebrow={t.recipes.eyebrow} titleLead={t.recipes.titleLead} titleAccent={t.recipes.titleAccent} intro={t.recipes.intro} data-id="element-449" data-mp="15dbq41w0upgb" />

      <div className="bg-creme" data-id="element-450" data-mp="1adzf6i0oww7w">
        <img src={media.alfajoresBoard} alt="Alfajores artisanaux à la noix de coco sur planche de bois" className="aspect-[21/9] w-full object-cover" data-id="element-451" data-mp="vns8ezk1p1n1" />
      </div>

      <section className="bg-creme py-20 md:py-28" data-id="element-452" data-mp="1obece8x6q8af">
        <div className="mx-auto max-w-5xl px-6 md:px-12" data-id="element-453" data-mp="1o9tdk73u836r">
          <div className="space-y-14" data-id="element-454" data-mp="1t3o5tyxidqhg">
            {t.recipes.items.map((recipe, index) => <motion.article key={recipe.id} initial={{
            opacity: 0,
            y: 28
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.06
          }} className="border border-caramel/25 bg-creme-dark p-8 md:p-12" data-id="element-455" data-mp="1yzq0e8cbsfcn" data-mpi={index}>
                <h2 className="mb-3 font-serif text-2xl text-cacao-900 md:text-3xl" data-id="element-456" data-mp="2homti8vzl1ta">
                  {recipe.title}
                </h2>

                <div className="mb-6 flex flex-wrap items-center gap-6 font-sans text-xs uppercase tracking-[0.14em] text-caramel" data-id="element-457" data-mp="2cpjmiiwg4lio">
                  <span className="flex items-center gap-2" data-id="element-458" data-mp="2mo98onvdks4q">
                    <Clock size={15} strokeWidth={1.5} aria-hidden="true" data-id="element-459" data-mp="2mosghbrba051" />
                    {recipe.time}
                  </span>
                  <span className="flex items-center gap-2" data-id="element-460" data-mp="xb5oi5lmmh1e">
                    <UtensilsCrossed size={15} strokeWidth={1.5} aria-hidden="true" data-id="element-461" data-mp="sbstuyoik5o9" />
                    {recipe.yield}
                  </span>
                </div>

                <p className="mb-10 font-serif text-lg italic leading-relaxed text-cacao-800" data-id="element-462" data-mp="1qzbignqv68m8">
                  {recipe.description}
                </p>

                <div className="grid gap-10 md:grid-cols-2" data-id="element-463" data-mp="1vzg38pyt1pi9">
                  <div data-id="element-464" data-mp="20y12on68g55n">
                    <h3 className="mb-5 font-sans text-[11px] uppercase tracking-[0.2em] text-or" data-id="element-465" data-mp="20wq0uswcl7h6">
                      {t.recipes.ingredientsLabel}
                    </h3>
                    <ul className="space-y-3 font-sans text-sm font-light text-cacao-700" data-id="element-466" data-mp="29p9s38ab89rz">
                      {recipe.ingredients.map(ingredient => <li key={ingredient} className="flex items-start gap-3 border-b border-caramel/15 pb-3" data-id="element-467" data-mp="2eqgyb2wt10wj">
                          <span aria-hidden="true" className="mt-2 h-1 w-1 shrink-0 rounded-full bg-caramel" data-id="element-468" data-mp="2okprztxkmzwa" />
                          {ingredient}
                        </li>)}
                    </ul>
                  </div>

                  <div data-id="element-469" data-mp="3u83ssghjmm76">
                    <h3 className="mb-5 font-sans text-[11px] uppercase tracking-[0.2em] text-or" data-id="element-470" data-mp="3u8nb3yb3vclq">
                      {t.recipes.stepsLabel}
                    </h3>
                    <ol className="space-y-4 font-sans text-sm font-light leading-relaxed text-cacao-700" data-id="element-471" data-mp="qr5761ygepql">
                      {recipe.steps.map((step, stepIndex) => <li key={step} className="flex gap-4" data-id="element-472" data-mp="lxsgzne4mavq" data-mpi={stepIndex}>
                          <span className="font-serif text-lg italic text-caramel" data-id="element-473" data-mp="h0aiys1ndg2i">
                            {stepIndex + 1}
                          </span>
                          <span data-id="element-474" data-mp="19pzj736j9c32">{step}</span>
                        </li>)}
                    </ol>
                  </div>
                </div>
              </motion.article>)}
          </div>
        </div>
      </section>

      <PromoBanner data-id="element-475" data-mp="z844x2llhqvl" />
    </>;
}